import React, { useState, useEffect } from "react";
import { Grid, Button, Input, Divider, Dropdown, Header } from 'semantic-ui-react'
import { apiCall } from "../util/Api";
export default function LocationSelector(props) {

    const { stores, setStores, range, setRange, mapView, isbn = "", setSelected, location, isUSA = false, loading = true, pc = "" } = props;
    const [postalCode, setPostalCode] = useState(pc);
    const [postalValid, setPostalValid] = useState(false);




    const ranges = (isUSA) ? [
        { key: '25', value: '25', text: '15mi' },
        { key: '50', value: '50', text: '30mi' },
        { key: '100', value: '100', text: '60mi' },
        { key: '300', value: '300', text: '180mi' }
    ] : [
        { key: '25', value: '25', text: '25km' },
        { key: '50', value: '50', text: '50km' },
        { key: '100', value: '100', text: '100km' },
        { key: '300', value: '300', text: '300km' }
    ]





    const onhandLabel = "In stock";
    const onorderLabel = "On order";
    const unknownLabel = "";
    const preorderLabel = "Pre-order";

    const drawStatus = (_item) => {

        let { url, onhand = null, onorder = null, is_preorder = null } = _item;


        // Pre-Order
        if (is_preorder) {
            return (<span style={{ "color": "orange", "float": "right", "padding": "1px 3px" }}><small>{preorderLabel}</small></span>)
        }

        // In stock
        if (onhand) {
            return (<span style={{ "color": "#419f4a", "float": "right", "padding": "1px 3px" }}><small>{onhandLabel}</small></span>)
        }

        // On Order
        if (!onhand && onorder) {
            return (<span style={{ "color": "orange", "float": "right", "padding": "1px 3px" }}><small>{onorderLabel}</small></span>)
        }

        // No inventory
        if (!onhand && !onorder && isbn && url !== "") {
            return (<span style={{ "color": "#3b6c94", "float": "right", "padding": "1px 3px" }}><small>{unknownLabel}</small></span>)
        }

        return (<></>)

    }



    const drawItems = () => {


        if (stores.rows.length < 1) {
            return (<>
                <br /><br />
                <Header style={{ "textAlign": "center" }} size="small" as='h2'>
                    <div className="shim" />
                    No stores found
                    <Header.Subheader>
                        No stores found in your location.
                    </Header.Subheader>
                </Header>
                <br /><br /><br />

            </>)
        }


        return stores.rows.map((item, index) => {
            return drawItem(item, index);
        })
    }

    const visitSite = (_url) => {
        window.open(_url, "_blank");
    }



    const validatePostalCode = (value) => {
        const raw = value.trim();

        const normalized = raw.replace(/[\s-]/g, "").toUpperCase();

        const CA_REGEX = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;
        const US_REGEX = /^\d{5}(\d{4})?$/; 

        const isValid =
            CA_REGEX.test(normalized) ||
            US_REGEX.test(normalized);

        if (postalCode !== normalized) {
            setPostalCode(normalized);
        }

        if (postalValid !== isValid) {
            setPostalValid(isValid);
        }
    };


    useEffect(() => {

        if(postalValid){
           props.fetchStores(postalCode);
        }

    }, [postalValid, postalCode])

    const postalFocus = (_code) => {
        setPostalValid(true)
    }

    const test = (_item) => {

        setSelected(_item);
    }

    const drawItem = (_item, _index) => {

        return (

            <div onClick={() => test(_item)} className="locationItem" key={_index}>

                <div style={{ "padding": "14px" }}>

                    <Header size="tiny" as='h2'>

                        <div style={{ "float": "right", "fontWeight": "normal" }}>
                            {drawStatus(_item)}
                        </div>
                        <div style={{ "maxWidth": "280px" }}>
                            {_item.name} -<span style={{ color: "#49af14" }}>  {(isUSA) ? _item.distance_mi + "mi" : _item.distance_km + "km"}</span>
                        </div>
                        <div className="shim" />
                        <Header.Subheader>
                            {_item.address}
                        </Header.Subheader>
                        <div className="shim" />
                        <Header.Subheader>
                            {_item.city}, {_item.province} {_item.country}
                        </Header.Subheader>
                        <Header.Subheader>
                            <div className="shim" />
                            <strong><a href={"tel:" + _item.phone}>{_item.phone} &nbsp;</a></strong>
                            <div style={{ "float": "right" }}>
                                <Button onClick={() => visitSite(_item.url)} style={{ "padding": "4px 10px", "textAlign": "right", "marginTop": "auto" }} primary size="mini" content='Visit' />
                            </div>
                        </Header.Subheader>
                    </Header>
                </div>



                <Divider style={{ "margin": "0px", "opacity": "0.3" }} />
            </div>
        )

    }


    if (mapView || loading) {
        return (<></>)
    }



    return (
        <>
            <div style={{ "padding": "14px", backgroundColor: "#ddd", "boxShadow": "inset 0px 0px 2px 0px rgba(0,0,0,0.1)" }}>
                <Grid columns={2}>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Input maxLength="7" class="inputpadding" error={(!postalValid && postalCode !== "")} value={postalCode} onChange={(e, { value }) => validatePostalCode(value)} style={{ "width": "100%", "fontSize": "16px", "padding": "0px" }}  placeholder="Enter postal/zip code" />
                        </Grid.Column>
                        <Grid.Column style={{ "width": "80px" }} width={4}>
                            <div style={{ "float": "right" }}><Dropdown selection onChange={(e, { name, value }) => setRange(value)} value={range} compact placeholder={ranges[0].text} options={ranges} /></div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
            <div className="itemsWrapper" style={{ "display": (mapView) ? "none" : "block" }}>
                {drawItems()}
            </div>

        </>
    )
}